import React from "react";
import { useCustomParams } from "../../../../hooks/useCustomParams";
import { useRemoveAllFilters } from "../../../../hooks/useRemoveAllFilters";
import Client from "./Client";
import Building from "./Building";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import Download from "./Download";
import { isAdmin } from "../../../../utils/helpers";
import DownloadAuditReport from "../../../Client/detail/components/Units/DownloadAuditReport";
import { downloadAuditReport } from "../../../../sevices/leadComplianceApi";
import { isSelfService } from "../../../../utils/helpers";

function RightFilters({ complianceType, selfServiceFilter = false }) {
  const [removeAll] = useRemoveAllFilters();
  const [status, updateStatus] = useCustomParams("status");
  const [building, setBuilding] = useCustomSearchParams("building");
  const [client, setClient] = useCustomSearchParams("client");
  const removeFilter = () => {
    removeAll(["status", "building", "client"]);
  };
  return (
    <div className="d-flex align-items-center mr-2">
      <div>
        {status || building || client ? (
          <p className="clear-filter" onClick={removeFilter}>
            Clear Filter
          </p>
        ) : (
          ""
        )}
      </div>
      { isAdmin() && <Client complianceType={complianceType} selfServiceFilter={selfServiceFilter}/>}
      <Building complianceType={complianceType} showBuilding={true}/>
      {/* <Download /> */}
      {(!isAdmin() && !isSelfService()) && (
        <DownloadAuditReport
          building={building}
          client={client}
          downloadAuditReportPdf={downloadAuditReport}
          reportId={"mailerPdfId"}
        />
      )}
    </div>
  );
}

export default RightFilters;
